import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
} from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideStore, Store } from '@ngxs/store';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';

import { appRoutes } from './app.routes';
import { AppState, bootstrapAppState } from './app.state';
import {
  ForgotPasswordState,
} from './forgot-password/store/forgot-password.state';
import { StatisticsState } from '@shared/statistics/store/statistics.state';
import { StorageService } from '@shared/services/storage.service';
import interceptors from '@shared/interceptors';
import { ngxsConfig, ngxsDevtoolsConfig } from '../ngxs.config';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { Icons } from '@icons';
import { SentryService } from '@shared/services/sentry.service';

SentryService.init();

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideIonicAngular({
      mode: 'ios',
      backButtonIcon: Icons.IC_ARROW_LEFT,
      backButtonText: '',
    }),
    provideRouter(
        appRoutes,
        withPreloading(PreloadAllModules),
        withComponentInputBinding(),
    ),
    provideHttpClient(
        withFetch(),
        withInterceptors(interceptors),
    ),
    provideStore(
        [AppState, ForgotPasswordState, StatisticsState],
        ngxsConfig,
        withNgxsReduxDevtoolsPlugin(ngxsDevtoolsConfig),
        withNgxsStoragePlugin({
          keys: [
            'app.token',
            'app.locale',
            'app.onboarding',
          ],
        }),
    ),
    provideAppInitializer(async () => {
      const store = inject(Store);
      const storageService = inject(StorageService);
      await bootstrapAppState(store, storageService);
    }),
    SentryService.provideSentryErrorHandler(),
  ],
};
